import { trpc } from 'pos-client/utils/trpc.ts';
import { time } from 'pos-shared/utils/millisecondsHelper.ts';

export const useAllUsers = (
  includeAuditData = false,
  includeSchedulesData = false
) => {
  const {
    data: users,
    isLoading: isLoadingUsers,
    isFetching: isFetchingUsers,
    ...rest
  } = trpc.getAllUsers.useQuery(
    {
      'Include.AuditData': includeAuditData,
      'Include.SchedulesData': includeSchedulesData,
    },
    {
      cacheTime: time.oneHourInMilliseconds,
      staleTime: time.tenSecs,
    }
  );

  // filters out id's which are duplicated as these are causing issues with FE
  const uniqueUsers = users
    ? Array.from(new Map(users.results.map((user) => [user.id, user])).values())
    : [];

  return {
    users: { ...users, results: uniqueUsers },
    isLoadingUsers,
    isFetchingUsers,
    ...rest,
  };
};
